import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar from "../SideBar/SideBar";
import "./layout.scss";

const Layout = () => {
  const location = useLocation();
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const isHomePage = location.pathname === "/home";

  return (
    <div className="app-container">
      <Header />
      <div className={`layout-body ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
        <Sidebar isOpen={isSidebarOpen} />
        <main
          className={`cm-content-wrapper ${isHomePage ? "no-padding" : "with-padding"}`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
